module.exports = __SPARKY_LIBS__["i18nextICU"];